import styleInject from './../../externals/style-inject/dist/style-inject.es.js';

var css_248z = ".CCExpiryDateIcon-module_ccExpiryDateIcon__kaWI7 {\n  line-height: normal;\n  height: 24px;\n}";
var styles = {"ccExpiryDateIcon":"CCExpiryDateIcon-module_ccExpiryDateIcon__kaWI7"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=CCExpiryDateIcon.module.scss.js.map
